/**
 * Tracks app instances as they're loaded
 */
let registeredApps = {};
let instances = {};
/**
 * The method used to retrieve the cached metadata for the mini-app using its instance Id.
 * @param instanceId The instance unique ID that is used to cache the configuration of the app.
 * For apps created using generator v6.x.x you can use the tag-name of the web component.
 */
export function getAppMetaDataForInstanceId(instanceId) {
    return (instances[instanceId] && instances[instanceId].appMetaData) || undefined;
}
/**
 * The method used to retrieve the authConfig for the miniApp using its instance Id.
 * @param instanceId The instance unique ID that is used to cache the configuration of the app.
 * For apps created using generator v6.x.x you can use the tag-name of the web component.
 */
export function getAuthConfigForInstanceId(instanceId) {
    return (instances[instanceId] && instances[instanceId].authConfig) || undefined;
}
export function getRegisteredApp(id) {
    return registeredApps[id];
}
/**
 * Registers and caches the instance of the mini-app's appLoaderConfig.
 * @param instanceId The instance unique ID that will be used to cache the configuration of the app.
 * @param appLoaderConfig The config that will be cached under the instanceId name
 */
export function registerInstance(instanceId, appLoaderConfig) {
    const { appMetaData: { id, tag } } = appLoaderConfig;
    registeredApps[id] = appLoaderConfig;
    instances[instanceId] = appLoaderConfig;
    /**
     * added to support backward compatibility to older apps that used to say the config cache as tag name
     */
    if (tag) {
        instances[tag] = appLoaderConfig;
    }
}
/**
 * Resets the cached configurations.
 */
export function reset() {
    registeredApps = {};
    instances = {};
}
//# sourceMappingURL=index.js.map